import { UpOutlined } from "@ant-design/icons";

const CollapseExpandIcon = ({ isActive }: { isActive?: boolean }) => (
	<UpOutlined rotate={isActive ? 0 : -180} />
);

export default CollapseExpandIcon;
